import React from 'react'
import PropTypes from 'prop-types'
import './PrivateContent.scss'
import LockIcon from '../../assets/codicons/lock'

const PrivateContent = ({ caption, grey }) => {
  let descriptionClass = 'PrivateContent__description'
  if (grey) descriptionClass += ' PrivateContent__description--grey'
  return (
    <div className='PrivateContent'>
      <div className={descriptionClass}>
        <div className='PrivateContent__lock'>
          <LockIcon />
        </div>
        <div className='PrivateContent__caption'>{caption}</div>
      </div>
    </div>
  )
}

PrivateContent.propTypes = {
  caption: PropTypes.string,
  grey: PropTypes.bool
}

export default PrivateContent
